import * as api from '../../../clients/benutzerverwaltung';

import {Action} from '@ngrx/store';

export const POST_BENUTZER_ENTRA_ID_ENTKOPPELN_ADMIN = '[BenutzerverwaltungModul] PostBenutzerEntraIdEntkoppelnAdmin laden';
export const POST_BENUTZER_ENTRA_ID_ENTKOPPELN_ADMIN_AUSFUEHREN = '[BenutzerverwaltungModul] PostBenutzerEntraIdEntkoppelnAdmin ausführen';
export const POST_BENUTZER_ENTRA_ID_ENTKOPPELN_ADMIN_ERFOLGREICH = '[BenutzerverwaltungModul] PostBenutzerEntraIdEntkoppelnAdmin laden erfolgreich';
export const POST_BENUTZER_ENTRA_ID_ENTKOPPELN_ADMIN_FEHLER = '[BenutzerverwaltungModul] PostBenutzerEntraIdEntkoppelnAdmin Ladefehler';
export const POST_BENUTZER_ENTRA_ID_ENTKOPPELN_ADMIN_NICHT_AUSGEFUEHRT = '[BenutzerverwaltungModul] PostBenutzerEntraIdEntkoppelnAdmin nicht ausgeführt (evtl. Offline)';


export class PostBenutzerEntraIdEntkoppelnAdminAction implements Action {
    readonly type = POST_BENUTZER_ENTRA_ID_ENTKOPPELN_ADMIN;
        constructor(public benutzerRequest: api.BenutzerRequest, public optPayload: any = null) {}
    }
export class PostBenutzerEntraIdEntkoppelnAdminAusfuehrenAction implements Action {
    readonly type = POST_BENUTZER_ENTRA_ID_ENTKOPPELN_ADMIN_AUSFUEHREN;
        constructor(public benutzerRequest: api.BenutzerRequest, public optPayload: any = null) {}
    }
export class PostBenutzerEntraIdEntkoppelnAdminErfolgreichAction implements Action {
    readonly type = POST_BENUTZER_ENTRA_ID_ENTKOPPELN_ADMIN_ERFOLGREICH;
        constructor(public payload: api.BenutzerIdentifier, public benutzerRequest: api.BenutzerRequest, public optPayload: any = null) {}
    }
export class PostBenutzerEntraIdEntkoppelnAdminFehlerAction implements Action {
    readonly type = POST_BENUTZER_ENTRA_ID_ENTKOPPELN_ADMIN_FEHLER;
        constructor(public payload: any, public benutzerRequest: api.BenutzerRequest, public optPayload: any = null) {}
    }
export class PostBenutzerEntraIdEntkoppelnAdminNichtAusgefuehrtAction implements Action {
    readonly type = POST_BENUTZER_ENTRA_ID_ENTKOPPELN_ADMIN_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type BenutzerverwaltungCommandBenutzerEntraIdEntkoppelnAdminActions =
    PostBenutzerEntraIdEntkoppelnAdminAction
    | PostBenutzerEntraIdEntkoppelnAdminAusfuehrenAction
    | PostBenutzerEntraIdEntkoppelnAdminErfolgreichAction
    | PostBenutzerEntraIdEntkoppelnAdminFehlerAction
    | PostBenutzerEntraIdEntkoppelnAdminNichtAusgefuehrtAction
    ;
